import React, { useEffect, useState } from "react";
import Styles from "./ClientHeader.module.scss";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import { handleClientLogout } from "../Func/clientLogout";
import { notifyOpenClientProfile } from "../Func/Storage";
import useClientAuthSession from "../../Hooks/useClientAuthSession";
import {
  login,
  subUrl,
  signup,
  manualdownload,
  toLoginPageUrl
} from "../../Api/SubUrl";
import { Path } from "../../Api/Path";
import { useRef } from "react";
function ClientHeader() {
  const menuHorizontal = useRef();
  const handleClose = () => {
    menuHorizontal.current.click();
  };

  const handleLogout = (event) => {
    event.preventDefault();
    handleClose();
    handleClientLogout(() => {
      window.location.replace(toLoginPageUrl(login));
    });
  };

  const { isAuthenticated } = useClientAuthSession();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Navbar
      className={clsx(Styles.Navbar, { [Styles.scrolled]: isScrolled })}
      bg="light"
      expand="lg"
    >
      <Container className={clsx(Styles.container)}>
        <Navbar.Brand className={clsx(Styles.brand)}>
          <NavLink
            className={clsx(Styles.BrandWrap)}
            to={login}
            onClick={() => {
              if (isAuthenticated) notifyOpenClientProfile();
            }}
          ></NavLink>
        </Navbar.Brand>

        <Navbar.Toggle
          className={clsx(Styles.btn)}
          aria-controls="basic-navbar-nav"
          ref={menuHorizontal}
        />

        <Navbar.Collapse
          id="basic-navbar-nav"
          className={clsx(Styles.menuHorizontalWrap)}
        >
          <Nav className={clsx(Styles.menuHorizontal, "me-auto")}>
            <NavLink
              to={subUrl}
              onClick={() => handleClose()}
              className={clsx(Styles.itemNav)}
            >
              Trang chủ
            </NavLink>

            <NavLink
              target="_blank"
              className={clsx(Styles.itemNav)}
              to={Path.Fanpage}
            >
                  <span className={clsx(Styles.itemHover)} />
                  Fanpage
            </NavLink>

            <NavLink
              target="_blank"
              className={clsx(Styles.itemNav)}
              to={manualdownload}
            >
              <span className={clsx(Styles.itemHover)} />
              Tải ngay
            </NavLink>

            <a
              href={toLoginPageUrl(login)}
              onClick={() => handleClose()}
              className={clsx(Styles.itemNav)}
            >
              {isAuthenticated ? "Tài khoản" : "Đăng nhập"}
            </a>

            {isAuthenticated ? (
              <>
                <a
                  rel="noopener noreferrer"
                  onClick={handleLogout}
                  href={toLoginPageUrl(login)}
                  className={clsx(Styles.itemNav)}
                >
                  Đăng xuất
                </a>
              </>
            ) : null}
            <a
              rel="noopener noreferrer"
              href={toLoginPageUrl(signup)}
              onClick={() => handleClose()}
              className={clsx(Styles.itemNav)}
            >
              Đăng ký
            </a>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default ClientHeader;
